import * as React from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';

import PageBase from '../../components/layout/PageBase';
import IntroduceBox from '../../components/pages/get-preapproved';
import { isMobile } from '../../lib/getDeviceSize';

import style from '../../styles/sass/pages/GetPreApproved.module.scss';
import track from '../../lib/track';

interface Props {
  classes: any;
}
const styles = createStyles({
  buttonMediumGreen: {
    '&:hover': {
      backgroundColor: '#1a4d45',
    },
    alignSelf: 'center',
    backgroundColor: '#195A50',
    color: 'white',
    fontSize: 18,
    fontWeight: 'bold',
    height: 55,
    letterSpacing: 2,
    marginBottom: 50,
    marginTop: 35,
    textTransform: 'uppercase',
    width: 275,
    borderRadius: 20,
  },
  preApprovalInfoContainer: {
    height: 'auto',
    padding: isMobile() ? 'auto' : 0,
    textAlign: 'left',
    width: isMobile() ? (window.innerWidth < 350 ? '100%' : 350) : 640,
  },
});

export function GetPreApproved(props: Props) {
  const { classes } = props;
  React.useEffect(() => {
    track.trackPage('Get Preapproved');
  }, []);
  return (
    <PageBase disableOverflow title="Torii - get pre-approved for a mortgage">
      <div className="page-container">
        <div className={style.preApprovedContainer}>
          <div className={style.cardContentWrapper}>
            <IntroduceBox />
          </div>
          <div
            className={`col-xs-12 center-xs ${style.preApprovalInfo} ${classes.preApprovalInfoContainer}`}
          >
            <p className={[style.textStyle, style.bold].join(' ')}>
              What does pre-approval mean?
            </p>
            <br />
            <p className={style.textStyle}>
              Pre-approval is the process by which a bank or lender evaluates
              your finances and credit history to determine if you are eligible
              for a mortgage. If you qualify, you will receive a pre-approval
              letter, which shows how much you can afford.
            </p>
            <br />
            <p className={[style.textStyle, style.bold].join(' ')}>
              Why is pre-approval important?
            </p>
            <br />
            <p className={style.textStyle}>
              In competitive markets, it's important for buyers to be
              pre-approved so that they can act quickly when they find the right
              home. Sellers expect buyers to be pre-approved to ensure that the
              deal won’t fall through due to financing issues.
            </p>
            <br />
            <p className={[style.textStyle, style.bold].join(' ')}>
              What do I need to get pre-approved?
            </p>
            <br />
            <p className={style.textStyle}>
              In order to get pre-approved, a lender will request the following:
            </p>
            <br />
            <ul style={{ listStyle: 'disc', lineHeight: '24px', margin: 0 }}>
              <li className={style.textStyle}>W-2 Statements</li>
              <li className={style.textStyle}>Current Paystubs</li>
              <li className={style.textStyle}>Recent Tax Returns</li>
              <li className={style.textStyle}>
                Proof of Income for Spouse/Partner
              </li>
              <li className={style.textStyle}>Bank Statements</li>
              <li className={style.textStyle}>Credit Report</li>
            </ul>
            <br />
            <p className={[style.textStyle, style.bold].join(' ')}>
              Other resources related to pre-approval:
            </p>
            <br />
            <ul style={{ listStyle: 'disc', lineHeight: '24px', margin: 0 }}>
              <li className={style.textStyle}>
                <a
                  href="https://blog.toriihomes.com/pre-qualification-pre-approval-pre-commitment-which-is-which/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Pre-qualification, pre-approval, pre-commitment
                </a>
                … Which is which?
              </li>
              <li className={style.textStyle}>
                Before the pre-approval:{' '}
                <a
                  href="https://blog.toriihomes.com/before-the-pre-approval-5-things-your-lender-wants-you-to-know/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  5 things your lender wants you to know
                </a>
              </li>
              <li className={style.textStyle}>
                <a
                  href="https://blog.toriihomes.com/first-time-home-buyer-mistakes-avoid/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  First-time home buyer mistakes
                </a>{' '}
                (and how to avoid them)
              </li>
            </ul>
            <br />
          </div>
        </div>
      </div>
    </PageBase>
  );
}

export default withStyles(styles)(GetPreApproved);
